import * as types from '../types.js';

export default {
	html: `
		<form id="product-packagings-print-report" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products-pkg-report"></datalist>
			<p class="fss">Exporta todas as colunas do cadastro de embalagens (CSV). Filtros opcionais.</p>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Filtrar por produto">Produto
					<input id="product_id" type="text" list="products-pkg-report" placeholder="opcional — escolha a empresa">
				</label>
			</div>
			<div class="fsb">
				<label title="Nível hierárquico">Nível
					<select id="level">
						<option value="">Todos</option>
						<option value="P">Primária (P)</option>
						<option value="S">Secundária (S)</option>
						<option value="T">Terciária (T)</option>
					</select>
				</label>
				<label title="Ativas / inativas no cadastro">Situação
					<select id="status">
						<option value="all">Todas</option>
						<option value="active">Somente ativas</option>
						<option value="inactive">Somente inativas</option>
					</select>
				</label>
				<label title="Limite de linhas">Máx. linhas
					<input id="max_rows" type="text" value="50000" placeholder="50000">
				</label>
			</div>
			<div class="fsb mtm">
				<span class="fss" style="color:#666;">UTF-8 com BOM (Excel). Colunas: empresa, IDs, SKU, nome produto, fabricante, código, nível, fator, GTIN, QR, capacidade terciária, padrão, inativa.</span>
				<span>
					<button type="button" class="bn_Escape button">Cancelar</button>
					<button type="submit" class="bn_Enter button">Gerar CSV</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#product-packagings-print-report',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{
			properties: { selector: '#product_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('products', { labels: ['sku', 'name'] }),
			],
		},
		{ properties: { selector: '#level' }, types: [] },
		{ properties: { selector: '#status' }, types: [] },
		{ properties: { selector: '#max_rows' }, types: [types.number(0, 0)] },
	],
};
